import React from 'react';
import NavTagline from '../nav-tagline/nav-tagline';
import Footer from './Footer';

const ScheduledOutage = () => {

    return (
        <div className="ScheduleOutage">
            <NavTagline />
            <section class="layout-container">
                <div className="container ctr">
                    <div className="text-size3 or-clr"><i class="bi bi-cone-striped"></i></div>
                    <div className="text-size4"><p>We are currently undergoing our routine maintanence and will be back very soon. </p> Thank you for your patience! </div>
                    <div className="text-size9 sp-margin10">If you need immediate support, please call 1.888.470.9913 or email us at <a href="mailto: support@secureexsolutions.com">support@secureexsolutions.com</a>.</div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default ScheduledOutage;
